/**
 * PWA features and install prompt disabled. Unregister service worker completely.
 */

export default (() => {
  // Unregister any active service workers to disable PWA features
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      for (let registration of registrations) {
        registration.unregister()
      }
    })
  }
})()
